// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** Resolves a dot-path key (e.g. "nav.today") in a nested dictionary; returns the key itself when missing. */
export function resolve(dict, key) {
    let node = dict;
    for (const part of key.split(".")) {
        if (node && typeof node === "object" && part in node) {
            node = node[part];
        }
        else {
            return key;
        }
    }
    return typeof node === "string" ? node : key;
}
export function interpolate(template, vars) {
    if (!vars)
        return template;
    return template.replace(/\{\{(\w+)\}\}/g, (_match, key) => String(vars[key] ?? ""));
}
